import { render, staticRenderFns } from "./EventsCurrent.vue?vue&type=template&id=96e4263e&"
import script from "./EventsCurrent.vue?vue&type=script&lang=js&"
export * from "./EventsCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports